<template>
	<div class="modal-wrapper modal" :class="{ dark: darkTheme }" @click="close">
		<div class="modal-holder" @click.stop>
			<icon-svg v-if="icon" class="ml-auto mr-auto mb-8" :icon="icon" />
			<span v-if="title" class="modal-title">
				{{ title }}
			</span>
			<div class="modal-content">
				<slot />
			</div>
			<template v-if="!isLoading">
				<div v-if="secondButtonText" class="modal-buttons">
					<primary-button class="button" large @click="firstButtonAction">
						{{ capitalizedFirstButtonText }}
					</primary-button>
					<primary-button class="button" large @click="secondButtonAction">
						{{ capitalizedSecondButtonText }}
					</primary-button>
				</div>
				<div v-else class="modal-button simple-button">
					<primary-button class="button w-100" large @click="firstButtonAction">
						{{ capitalizedFirstButtonText }}
					</primary-button>
				</div>
			</template>
			<div v-else class="modal-button simple-button">
				<primary-button class="button w-100" large loading />
			</div>
		</div>
	</div>
</template>

<script>
import PrimaryButton from '@/components/Buttons/PrimaryButton.vue'
import IconSvg from '@/components/IconSvg.vue'
import { getCapitalizedWords } from '@/utils/helpers'

export default {
	name: 'Modal',

	components: { IconSvg, PrimaryButton },

	props: {
		isLoading: {
			type: Boolean,
			default: false
		},

		title: {
			type: String,
			default: ''
		},

		secondButtonText: {
			type: String,
			default: ''
		},

		firstButtonText: {
			type: String,
			default: ''
		},

		firstButtonAction: {
			type: Function,
			default: () => {}
		},

		secondButtonAction: {
			type: Function,
			default: () => {}
		},

		closeOnClickOutside: {
			type: Boolean,
			default: false
		},

		darkTheme: {
			type: Boolean,
			default: false
		},

		icon: {
			type: String,
			default: ''
		}
	},

	computed: {
		capitalizedFirstButtonText() {
			if (!this.firstButtonText) return ''

			return getCapitalizedWords(this.firstButtonText)
		},

		capitalizedSecondButtonText() {
			if (!this.secondButtonText) return ''

			return getCapitalizedWords(this.secondButtonText)
		}
	},

	methods: {
		close() {
			if (this.closeOnClickOutside) this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.modal-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;

	.modal-holder {
		display: block;
		padding-bottom: 0;

		.modal-title {
			padding-bottom: 0;
			margin-bottom: 16px;
			color: #816cc2;
		}

		.modal-content {
			margin-bottom: 20px;
			font-size: 14px;
			line-height: 20px;
			text-align: center;
			color: #1d1b25;
			opacity: 0.8;
		}

		.modal-buttons,
		.modal-button {
			margin: 0 -20px 0 -20px;

			.button {
				padding: 10px;
				border-radius: 0 0 10px 10px;
			}
		}

		.modal-buttons {
			display: flex;
			justify-content: space-between;
			white-space: nowrap;

			.button {
				width: calc(50% - 1px);
				border-radius: 0 0 10px 0;

				&:first-child {
					border-radius: 0 0 0 10px;
				}
			}
		}
	}

	&.dark {
		.modal-holder {
			background-color: $background-popup;
			border: 1px solid $border-color;

			.modal-title,
			.modal-content {
				color: $white;
			}
		}
	}

	@media (max-width: 480px) {
		.modal-holder {
			padding-right: 16px;
			padding-left: 16px;

			.modal-buttons,
			.modal-button {
				margin: 0 -16px 0 -16px;
			}
		}
	}
}
</style>
